import { handleResponse, nextJsonApi } from '@/API/core';

const notification = {
  getNotifications: async (
    employee_id: string,
    company_id: string,
    role: string
  ) => {
    let response = null;

    try {
      response = await nextJsonApi.get(
        '/notification?employee_id=' +
          employee_id +
          '&company_id=' +
          company_id +
          '&role=' +
          role
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  createNotification: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/notification', data);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateStatus: async (uniqueId: string, status: string) => {
    let response = null;
    try {
      response = await nextJsonApi.put('/notification', { uniqueId, status });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default notification;
